











































































































import {Component} from 'vue-property-decorator';
import GenericDistribution from '@/pages/Pages/Distributions/GenericDistribution.vue'
import WhatsappTemplate from '@/pages/Pages/Templates/WhatsappTemplate.vue'
import { MsgTransports } from '@/store/types';
import { SelectWings } from "wings-ui-components";

@Component({components: {GenericDistribution, WhatsappTemplate, SelectWings}})
export default class WhatsappDistribution extends GenericDistribution {

  transport = MsgTransports.WHATSAPP

  beforeRouteLeave(to:any, from:any, next:any) {
    this.beforeLeave(to,from,next)
  }
}
